export default __webpack_public_path__ + "static/media/profile-icon-red.e5b2022d.svg";